import { ChangeEvent } from 'react';

import {
  Checkbox,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  ListItemIcon,
  ListSubheader,
  Grid,
} from '@mui/material';
import { SnapshotAlarm } from 'types';

interface Props {
  alarms: SnapshotAlarm[] | undefined;
  selectedAlarmId: number | undefined;
  handleAlarmClicked: (alarm: SnapshotAlarm) => void;
  handleAlarmChecked: (
    event: ChangeEvent<HTMLInputElement>,
    alarm: SnapshotAlarm
  ) => void;
}

const AlarmList = ({
  alarms,
  selectedAlarmId,
  handleAlarmClicked,
  handleAlarmChecked,
}: Props) => {
  return (
    <List
      sx={{ overflow: 'auto', maxHeight: '70vh' }}
      dense
      subheader={
        <ListSubheader
          component='div'
          id='nested-list-subheader'
          style={{ borderRadius: '10px' }}
        >
          <Grid container justifyContent='space-between'>
            <Grid item>Alarms</Grid>
            <Grid item style={{ marginRight: '1.2rem' }}>
              Active
            </Grid>
          </Grid>
        </ListSubheader>
      }
    >
      {alarms?.map((alarm, idx) => (
        <ListItem
          button
          key={idx}
          onClick={() => handleAlarmClicked(alarm)}
          selected={alarm.id === selectedAlarmId}
        >
          <ListItemText>{alarm.name}</ListItemText>
          <ListItemSecondaryAction>
            <ListItemIcon>
              <Checkbox
                edge='start'
                name='enabled'
                onChange={(e) => handleAlarmChecked(e, alarm)}
                checked={Boolean(alarm.enabled)}
              />
            </ListItemIcon>
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export default AlarmList;
